import React, { useState, Fragment } from "react";
import gql from "graphql-tag";
import { Mutation, compose } from "react-apollo";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Formik } from "formik";
import * as Yup from "yup";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { withNotification } from "../../../notification/context";
import { QUERY } from "./index";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { setCloseStatsPanel } from "../../../data/ducks";

const FileGeneratorSchema = Yup.object().shape({
  layer: Yup.string().required("Requerido")
});

const styles = theme => ({
  button: {
    margin: theme.spacing.unit
  },
  fileZone: {
    borderWidth: 2,
    borderColor: "#DCDCDC",
    borderStyle: "dashed",
    borderRadius: 5,
    textAlign : "center",
    padding : 8
  },
  input: {
    display: "none"
  },
  contentActions : {
    marginBottom : 16, 
    marginRight  : 20,
  },
});

const UPDATE = gql`
  mutation uploadStatsFile($layer: ID!, $file: Upload!, $description: String!, $taskName: String!, $taskType: String!, $email: String!) {
    uploadStatsFile(layer: $layer, file: $file, description: $description, taskType: $taskType, taskName: $taskName, email: $email) {
      id
      status
      description
      createdAt
      updatedAt
      taskName
      taskType
      email
    }
  }
`;

const ButtonDownloadStatsFile = ({ classes, layer, openNotification, setCloseStatsPanel }) => {
  const [open, changeOpen] = useState(false);
  const handleOpen = () => {
    setCloseStatsPanel(true);
    changeOpen(true)
  };
  const handleClose = () => {
    setCloseStatsPanel(false);
    changeOpen(false)
  };

  return (
    <Fragment>
      <Button
        variant="outlined"
        color="primary"
        className={classes.button}
        onClick={handleOpen}
      >
        Cargar
      </Button>
      <Mutation
        mutation={UPDATE}
        update={(cache, { data: { uploadStatsFile } }) => {
          const { statsTaskByLayer } = cache.readQuery({
            query: QUERY,
            variables: {
              layer
            }
          });
          cache.writeQuery({
            query: QUERY,
            variables: {
              layer
            },
            data: {
              statsTaskByLayer: statsTaskByLayer.concat([uploadStatsFile])
            }
          });
        }}
      >
        {(createStatsFile, { loading, error }) => {
          return (
            <Dialog
              style={{padding : 16}}
              open={open}
              onClose={handleClose}
              aria-labelledby="download-stats-file-dialog"
              aria-describedby="download-stats-file-dialog"
            >
              <DialogTitle id="download-stats-file-dialog">
                <Typography align="center" variant="h5">Subir plantilla de datos estadísticos</Typography>
              </DialogTitle>
              <Formik
                initialValues={{
                  layer,
                  description: "",
                  email: "",
                  taskName: `Carga estadística ${new Date().toLocaleString()}`,
                  file: null,
                  taskType : 'STATS_UPLOAD',
                }}
                onSubmit={(values, { resetForm }) => {
                  return createStatsFile({ variables: values })
                    .then(() => {
                      openNotification("Archivo cargado correctamente.");
                      resetForm();
                      handleClose();
                    })
                    .catch(() => {
                      openNotification("Error al cargar el archivo.");
                    });
                }}
                validationSchema={FileGeneratorSchema}
              >
                {({
                  values,
                  handleChange,
                  handleSubmit,
                  isSubmiting,
                  errors,
                  setFieldValue,
                  touched
                }) => {
                  const emailValid = values.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
                  return (
                    <Fragment>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                          <Typography align="center">Por favor seleccione el archivo que desea cargar</Typography>
                        </DialogContentText>
                            <TextField
                              id="outlined-name"
                              label="Descripción"
                              name="description"
                              className={classes.textField}
                              value={values.description}
                              onChange={handleChange}
                              margin="normal"
                              variant="outlined"
                              fullWidth
                              multiline
                              rowsMax="4"
                              disabled={loading}
                              InputLabelProps={{
                                shrink: true
                              }}
                            />
                            <TextField
                              id="outlined-name"
                              label="Email"
                              name="email"
                              className={classes.textField}
                              value={values.email}
                              onChange={handleChange}
                              margin="normal"
                              variant="outlined"
                              fullWidth
                              multiline
                              disabled={loading}
                              InputLabelProps={{
                                shrink: true
                              }}
                            />
                            <TextField
                              id="outlined-name"
                              label="Nombre de la tarea"
                              name="taskName"
                              className={classes.textField}
                              value={values.taskName}
                              onChange={handleChange}
                              margin="normal"
                              variant="outlined"
                              fullWidth
                              multiline
                              rowsMax="4"
                              disabled={loading}
                              InputLabelProps={{
                                shrink: true
                              }}
                            />
                            <div className={classes.fileZone}>
                              <input
                                className={classes.input}
                                id="raised-button-file"
                                type="file"
                                onChange={({
                                  target: {
                                    files: [file]
                                  }
                                }) => {
                                  setFieldValue("file", file);
                                }}
                              />
                              <label htmlFor="raised-button-file">
                                <Button
                                  size="large"
                                  variant="contained"
                                  component="span"
                                  className={classes.margin}
                                  disabled={loading}
                                >
                                  Seleccionar archivo...
                                  <CloudUploadIcon
                                    className={classes.rightIcon}
                                  />
                                </Button>
                              </label>
                              {errors.file && touched.file && (
                                <p>{errors.file}</p>
                              )}
                              <Typography variant="body1">
                                {values.file
                                  ? `Seleccionado: ${values.file.name}`
                                  : "Ningun archivo seleccionado ..."}
                              </Typography>
                            </div>
                            <DialogContentText>
                              {error && (
                                <p>Error :( Por favor intenta de nuevo</p>
                              )}
                            </DialogContentText>
                            {loading ? 
                              (
                                <div>
                                  <LinearProgress />
                                  <DialogContentText>
                                    Cargando ...
                                  </DialogContentText>
                                </div>
                              ) : null
                            }
                      </DialogContent>
                      <DialogActions className={classes.contentActions}>
                        <Button
                          onClick={handleClose}
                          color="primary"
                          disabled={loading}
                          variant="outlined"
                        >
                          Cancelar
                        </Button>
                        <Button
                          onClick={handleSubmit}
                          color="primary"
                          autoFocus
                          variant="outlined"
                          disabled={
                            loading || 
                            isSubmiting || 
                            values.file === null || 
                            values.taskName === '' || 
                            values.email === '' || 
                            values.description === '' ||
                            !emailValid
                          }
                        >
                          Subir Archivo
                        </Button>
                      </DialogActions>
                    </Fragment>
                  );
                }}
              </Formik>
            </Dialog>
          );
        }}
      </Mutation>
    </Fragment>
  );
};

const mapDispatchToProps = dispatch => bindActionCreators({
  setCloseStatsPanel,
}, dispatch)

export default connect(null, mapDispatchToProps)(compose(
  withStyles(styles),
  withNotification
)(ButtonDownloadStatsFile));



// WEBPACK FOOTER //
// ./src/components/admin/carto/stats/button-upload-stats-file.js